import * as Icons from 'react-bootstrap-icons'

export const Icon = ({
  iconName,
} : {
  iconName: string
}) => {
  const IconComponent = Icons[iconName as keyof typeof Icons]
  
  return IconComponent ? <IconComponent /> : null
}
